<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { emailErrors } from 'src/plugins/validations'
import ClassVerified from 'src/components/Attend/ClassVerified'
// import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Attend',
  components: {
    ClassVerified
  },
  computed: {
    ...mapState('attend', {
      currentClass : s => s.class,
      classCode: s => s.classCode,
      sessions : s => s.sessions,
      signupComplete: s => s.signupComplete
    })
  },
  methods: {
    ...mapActions('attend', [
      'verifyCode'
    ]),
    ...mapMutations('attend', [
      'changeVerifyCode'
    ]),
    goToLogin(){
      this.$router.push('/login')
    }
  }
}

</script>

<template>
  <q-page class="row">
    <div id="attend-left" class="col-lg-6 col-md-6 col-sm-12 relative-position row items-center">
      <q-card-main class="content-center col-12" v-if="currentClass === null && !signupComplete">
        <form v-on:submit.prevent="verifyCode()">
          <h5 class="q-pa-md">Attend A Class</h5>
          <q-field class="q-pa-md">
            <q-input 
              name=""
              autofocus
              :value="classCode"
              clearable
              placeholder="Enter Class Code"
              stack-label="Class Code"
              :before="[{ icon: 'memory' }]"
              @input="val => changeVerifyCode(val)"/>
          </q-field>
          <div class="text-right">
            <q-field class="q-pa-md">
              <q-btn label="Validate Code" color="primary" @click="verifyCode"/>
            </q-field>
          </div>
        </form>
        <q-field class="outline col-12">
            <span class="text-bold">OR LOG-IN</span>
            <div class="float-right">
              <q-btn size="sm" label="Login" @click="goToLogin()" color="secondary" outline />
            </div>
        </q-field>        
      </q-card-main>
      <class-verified v-if="currentClass !== null || signupComplete" />
    </div>
    <div id="attend-picture" class="col-lg-6 col-md-6 relative-position mobile-hide"></div>
  </q-page>
</template>

<style scoped>
  #attend-left{
    border-top:5px solid #4d83ff;
    box-shadow: 0 0 95px #000000ab;
    position: relative;
    z-index: 1;
    padding:0 7%;
    background-image:url('../assets/img/login-left-bg.png');
    background-position:center bottom;
    background-repeat:no-repeat;
    background-color:#fff;
  }
  #attend-picture{
    background-size:cover;
    background-image:url('../assets/img/attend.jpg');
    background-position:right;
  }
  .q-btn.bg-primary{
    font-size: 15px !important;
    padding: 15px 51px;
    font-weight: 600;
    letter-spacing: 1px;
  }
  .outline{
    border:1px solid #ccc;
    border-radius:2px;
    margin:50px 15px 0;
    padding: 20px 30px;
  }
  .outline .text-bold{
    font-size:13px;
    vertical-align:middle;
    line-height: 25px;
  }
  .dotted-underline{
    border-bottom:1px solid #4d83ff;
    text-decoration: none;
    margin-top:4px;
    display:inline-block;
    color:#000;
    font-size:13px;
  }
</style>
